import { Box, Divider, Stack, Typography, Chip } from "@mui/material";
import { EmailOutlined, PhoneOutlined, LocationOnOutlined, PersonOutline, ReceiptLongOutlined } from "@mui/icons-material";

import { CardLayout } from "../v3";

export const OfficeDetails = ({ accountDetails = {} }) => {
  const isActive = accountDetails?.active;

  const address = accountDetails?.primaryAddress;
  const addressString = address
    ? [address.locality, address.state, address.pinCode, address.country].filter(Boolean).join(", ")
    : "Not Provided";

  const taxDetails = accountDetails?.taxDetails || {};
  const owner = accountDetails?.ownerUser;
  const ownerName =
    owner && (owner.firstName || owner.lastName) ? `${owner.firstName || ""} ${owner.lastName || ""}`.trim() : "Not Provided";

  const detailRows = [
    {
      leftLabel: "Primary Email",
      leftValue: accountDetails?.primaryEmail || "Not Provided",
      leftIcon: <EmailOutlined sx={{ fontSize: 18, color: "#674BF5", mr: 1 }} />,
      rightLabel: "Primary Phone",
      rightValue: accountDetails?.primaryPhone || "Not Provided",
      rightIcon: <PhoneOutlined sx={{ fontSize: 18, color: "#674BF5", mr: 1 }} />,
    },
    {
      leftLabel: "GST Number",
      leftValue: taxDetails.gstNumber || "Not Provided",
      leftIcon: <ReceiptLongOutlined sx={{ fontSize: 18, color: "#674BF5", mr: 1 }} />,
      rightLabel: "PAN Number",
      rightValue: taxDetails.panNumber || "Not Provided",
      rightIcon: <ReceiptLongOutlined sx={{ fontSize: 18, color: "#674BF5", mr: 1 }} />,
    },
    {
      leftLabel: "Owner Name",
      leftValue: ownerName,
      leftIcon: <PersonOutline sx={{ fontSize: 18, color: "#674BF5", mr: 1 }} />,
    },
  ];

  return (
    <CardLayout sx={{ margin: "11px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#674BF5" }}>
          Company Overview
        </Typography>

        <Chip
          label={isActive ? "Active" : "Inactive"}
          color={isActive ? "success" : "default"}
          size="small"
          sx={{ fontWeight: 600, px: 0.5 }}
        />
      </Box>

      <Stack spacing={2.5}>
        <Box>
          <Typography variant="caption" color="text.secondary">
            Company Name
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 600, textTransform: "uppercase", mt: 0.5, color: "text.primary" }}>
            {accountDetails?.name || "Not Provided"}
          </Typography>
        </Box>

        {detailRows.map((row, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Box sx={{ flex: "1 1 45%" }}>
              <Typography variant="caption" color="text.secondary">
                {row.leftLabel}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
                {row.leftIcon}
                <Typography variant="body2" sx={{ fontWeight: 500, color: "text.primary" }}>
                  {row.leftValue}
                </Typography>
              </Box>
            </Box>

            {row.rightLabel && (
              <>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ height: 35, alignSelf: "center", display: { xs: "none", sm: "block" } }}
                />

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="text.secondary">
                    {row.rightLabel}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
                    {row.rightIcon}
                    <Typography variant="body2" sx={{ fontWeight: 500, color: "text.primary" }}>
                      {row.rightValue}
                    </Typography>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        ))}

        <Box>
          <Typography variant="caption" color="text.secondary">
            Address
          </Typography>
          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 0.5 }}>
            <LocationOnOutlined sx={{ fontSize: 18, color: "#674BF5", mr: 1, mt: 0.2 }} />
            <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.5, color: "text.primary" }}>
              {addressString}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </CardLayout>
  );
};
